import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)

// 正确设置全局属性的方式
app.config.globalProperties.$ImageID = 0

app.use(router).mount('#app')

// App.prototype.$ImageID = 0

// createApp(App).use(router).mount('#app')
